var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonKeys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.359 15.886a5.739 5.739 0 00-2.412 1.976C-1.04 22.146.263 40.036.399 42.722c.072 1.444 1.146 2.584 2.478 2.87 1.872.408 74.05-15.628 87.646-19.446 2.234-.628 4.778-1.888 4.816-4.192l.3-17.642c.036-2.074-.482-4.078-2.534-4.3A2.87 2.87 0 0092.813 0C86.059.002 10.967 12.996 4.359 15.886",
    id: "a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.6073007%",
    y1: "47.118123%",
    x2: "72.6946579%",
    y2: "53.4702234%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA190",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A877B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.116 40.006C1.19 40.948-.01 42.65 0 45.014L.054 62.4c.002.716.352 1.432.99 1.926.64.492 1.388.65 1.968.362l78.912-39.366c1.974-.88 3.07-2.642 3.12-5.008.05-2.402 1.942-19.312-.046-20.314L3.116 40.006z",
    id: "d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38.1896685%",
    y1: "49.9346941%",
    x2: "94.6601098%",
    y2: "50.2271722%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA190",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A877B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M0 0L92.1238853 0 92.1238853 31.7953014 0 31.7953014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.448 0L1.835 67.288C.46 69.236.513 71.3.45 73.678L.001 89.926c-.07 2.612 2.368 1.91 3.284.704l47.377-62.418c2.092-2.758 2.922-4.6 3.036-8.564l.462-16.36C54.22 1.176 51.706 0 49.572 0h-.124",
    id: "i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.7938931%",
    y1: "71.0991956%",
    x2: "54.3985187%",
    y2: "22.0464101%",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA190",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A877B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "M0 0L58.1299588 0 58.1299588 109.490021 0 109.490021z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.826 74.308c-.598 2.302-.678 4.716-.998 7.072L2.57 97.924c-.114.844-.532 3.558-2.57 3.378 3.046.446 4.46-.316 5.264-3.326l22.18-83.14.842-10.266C28.46 2.428 27.828.586 25.192 0L5.826 74.308z",
    id: "n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9377091%",
    y1: "70.0856065%",
    x2: "50.0969006%",
    y2: "23.5992555%",
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA190",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A877B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.061 57.648c28.758-6.016 63.245-14.18 83.42-19.266 3.059-.77 6.49-2.052 6.643-5.198l.712-14.812c.342-7.154-.468-9.22-5.13-12.106l-6.452-3.994C97.364.484 93.842-.36 90.476.144L7.193 12.628C3.16 13.232.807 16.616.68 20.504L.017 40.87c-.22 6.746 1.688 9.274 4.016 10.84l3.158 2.124c5.414 3.642 6.83 4.96 13.87 3.814",
    fill: "#C89A6C",
    transform: "translate(-250 -439) translate(250 439) translate(0 38.102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.328 3.39l9.238 31.282-84.11 20.326c-1.982-.698-9.624-6.206-11.428-7.95-1.448-1.398-1.456-2.974-1.328-6.96l.628-19.854c.086-2.718 2.968-4.374 5.682-4.776L90.328 3.39z",
    fill: "#D1D3CA",
    transform: "translate(-250 -439) translate(250 439) translate(0 38.102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.509 29.8c11.278-1.89 79.3-7.782 82.544-19.216-.98-1.448-10.034-6.944-12.14-7.7-1.264-.452-2.638-.528-4.046-.208L9.01 15.458c-.714.11-1.23.67-1.406 1.368-.178.698.04 1.392.586 1.866l10.934 9.512c1.804 1.566 4.026 1.992 6.386 1.596",
    fill: "#FFF",
    transform: "translate(-250 -439) translate(250 439) translate(0 38.102)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -439) translate(250 439) translate(13.147 47.646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.359 15.886a5.739 5.739 0 00-2.412 1.976C-1.04 22.146.263 40.036.399 42.722c.072 1.444 1.146 2.584 2.478 2.87 1.872.408 74.05-15.628 87.646-19.446 2.234-.628 4.778-1.888 4.816-4.192l.3-17.642c.036-2.074-.482-4.078-2.534-4.3A2.87 2.87 0 0092.813 0C86.059.002 10.967 12.996 4.359 15.886",
    fill: "url(#b)",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.29 14.158c.724.558 1.768.43 2.33-.29a1.638 1.638 0 00-.292-2.312L2.68 4.894a1.67 1.67 0 00-2.33.29 1.638 1.638 0 00.292 2.312l8.648 6.662z",
    fill: "#BDAE8E",
    transform: "translate(-250 -439) translate(250 439) translate(5.524 51.133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.523 32.843c4.776-2.186 9.726-4.196 14.58-6.214C75.13 17.883 96.75 8.677 118.177.961c4.188-1.508 7.716-1.428 11.286 1.59l7.35 6.214c2.502 2.114 3.52 4.706 3.704 7.904.336 5.86-.684 11.538-.804 17.306-.072 3.46-1.78 6.412-4.976 7.87L55.88 81.183c-2.42 1.206-5.24.078-7.182-1.586-3.438-2.942-8.818-9.714-11.306-13.352-2.9-4.24-3.41-5.104-3.56-10.292-.134-4.7-.544-11.484.328-16.088.718-3.79 2.226-5.586 5.362-7.022",
    fill: "#C89A6C",
    transform: "translate(-250 -439) translate(250 439) translate(5.524 51.133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.26 29.571l-22.113-16.918-74.546 23.77c-2.704 2.242-2.386 5.798-2.548 8.216-.23 3.46-.044 7.978.048 11.222.128 4.456.344 4.682 2.996 8.562 1.332 1.944 8.898 11.144 10.736 12.716.76.652 1.936 1.424 3.086 1.262l82.34-48.83z",
    fill: "#D1D3CA",
    transform: "translate(-250 -439) translate(250 439) translate(5.524 51.133)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -439) translate(250 439) translate(56.924 64.728)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.116 40.006C1.19 40.948-.01 42.65 0 45.014L.054 62.4c.002.716.352 1.432.99 1.926.64.492 1.388.65 1.968.362l78.912-39.366c1.974-.88 3.07-2.642 3.12-5.008.05-2.402 1.942-19.312-.046-20.314L3.116 40.006z",
    fill: "url(#e)",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.052 67.482c1.216-1.36.242-3.648-1.49-5.114l-7.35-6.214c-3.19-2.698-6.05-1.73-8.048-1.01-13.438 4.84-68.652 27.316-78.402 31.78-2.024.926-2.69 2.378-.558 5.028 1.906 2.368 7.028 10.258 12.23 12.204 1.054.396 2.11.498 3.094.304 6.724-1.33 77.922-34.068 80.524-36.978",
    fill: "#FFF",
    transform: "translate(-250 -439) translate(250 439) translate(33.654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.865 95.84c-1.638-1.766-.206-3.37 1.432-1.602l8.65 9.694c.688.742.814 1.864.286 2.506-.53.644-1.518.562-2.206-.18L13.865 95.84z",
    fill: "#BDAE8E",
    transform: "translate(-250 -439) translate(250 439) translate(33.654)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -439) translate(250 439) translate(33.654)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.494 22.683c-.362 3.218-1.56 4.126-4.77 4.324l-76.154 4.72c-2.068.128-4.362.152-6.318-.64-1.98-.8-3.47-2.342-3.984-5.838-.412-2.79-.622-7.222 1.476-9.368 2.806-2.874 6.104-6.526 9.316-8.88 3.768-2.76 5.724-3.394 10.398-3.808 9.626-.852 19.334-1.374 28.986-1.856C60.972.81 71.506.375 82.04.003c3.204-.112 6.794 2.082 8.726 4.516C91.802 5.823 91.89 6.687 92 8.253c.312 4.42-.008 10.004-.506 14.43",
    fill: "#4C6772",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.535 11.424l69.452-4.538c-.464-1.232-4-4.516-7.33-4.402-18.682.648-44.518 1.768-59.698 3.094-4.164.364-5.672.78-9.168 3.318-2.158 1.568-5.42 4.954-8.926 8.46-1.52 1.606-1.202 6.198-.618 8.646l16.288-14.578z",
    fill: "#4C6772",
    transform: "translate(-250 -439) translate(250 439) translate(33.654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.853 6.614c1.06 1.166.09 16.74-.374 17.268-.488.556-1.574.726-2.4.776l-75.19 4.594c-4.427.27-6.247-1.018-7.443-2.834C10.16 18.15 17.162 9.984 32.438 9.052c6.054-1.158 52.817-2.014 56.415-2.438",
    fill: "#122E44",
    transform: "translate(-250 -439) translate(250 439) translate(33.654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.577 5.984c1.994.012 2.232 3.264.05 3.296-12.508.164-47.844 1.418-60.128 3.116-7.874 1.09-11.518 3.426-21.744 13.6-1.58 1.572-3.734.444-1.686-1.88 9.74-11.058 12.294-13.394 20.688-14.684 12.624-1.94 50.076-3.254 62.82-3.448",
    fill: "#131F24",
    transform: "translate(-250 -439) translate(250 439) translate(33.654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.427 6.321c.416.926.746 1.88.99 2.85.53 2.1-1.858 2.692-2.568.644a23.072 23.072 0 00-.946-2.334c.886-.528 1.68-.894 2.524-1.16",
    fill: "#96B5BD",
    transform: "translate(-250 -439) translate(250 439) translate(33.654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.03 136.279c1.685-2.034 3.42-4.032 5.159-6.02 5.302-6.072 10.696-12.076 16.106-18.056a1901.157 1901.157 0 0118.216-19.87c4.332-4.656 7.418-8.104 11.944-12.58 2.736-3.022 5.662-5.85 10.468-4.906l13.732 2.696c3.356.658 6.576 2.826 6.468 6.582l-.464 16.362c-.124 4.412-1.05 6.942-3.692 10.422l-44.82 59.054c-2.84 3.992-6.684 8.564-12.296 6.12l-13.356-5.81c-2.638-1.148-4.984-1.924-6.612-4.494-1.178-1.86-2.116-7.426-2.534-9.684-.618-3.324-1.216-6.738-1.648-10.092-.596-4.626.704-6.554 3.33-9.724",
    fill: "#C89A6C",
    transform: "translate(-250 -439) translate(250 439) translate(33.654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.536 103.346l-20.568-23.58-55.418 61.232c-.726 1.76-.78 3.24-.606 4.596.454 3.526 2.632 16.762 3.706 18.458 1.116 1.762 3.122 2.364 5.156 3.248l13.354 5.812c2.512 1.092 5.25-.712 6.832-2.934l47.544-66.832z",
    fill: "#D1D3CA",
    transform: "translate(-250 -439) translate(250 439) translate(33.654)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -439) translate(250 439) translate(111.348 80.744)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.448 0L1.835 67.288C.46 69.236.513 71.3.45 73.678L.001 89.926c-.07 2.612 2.368 1.91 3.284.704l47.377-62.418c2.092-2.758 2.922-4.6 3.036-8.564l.462-16.36C54.22 1.176 51.706 0 49.572 0h-.124",
    fill: "url(#j)",
    mask: "url(#k)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.283 56.426c.706-1.922-.71-3.758-2.762-4.162L65.79 49.568c-2.28-.448-4.272.802-5.92 2.424-11.75 11.57-54.356 58.696-54.82 60.544-.328 1.312.224 2.77 1.498 3.478 2.366 1.312 13.722 7.658 18.914 6.9 2.228-.324 3.532-1.134 4.966-2.684 10.48-11.326 50.464-60.014 51.856-63.804",
    fill: "#FFF",
    transform: "translate(-250 -439) translate(250 439) translate(82.154 28.462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.547 118.123a1.646 1.646 0 01-1-2.11c.31-.856 1.26-1.3 2.124-.992l16.884 6.058a1.647 1.647 0 011.002 2.11 1.664 1.664 0 01-2.126.992l-16.884-6.058z",
    fill: "#BDAE8E",
    transform: "translate(-250 -439) translate(250 439) translate(82.154 28.462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.882 5.65c1.734 1.459 1.666 3.82 1.538 5.739-.236 3.562-1.264 7.454-2.308 10.856-.506 1.65-1.614 2.902-3.152 3.688l-54.998 28.13c-3.584 1.832-6.024 1.112-9.406-.926l-8.744-5.27C.32 46.363-.672 43.295.474 40.637 2.258 36.503 5.564 30.5 8.47 26.669c1.908-2.518 3.512-3.532 6.25-4.978a164.882 164.882 0 015.52-2.752C33.682 12.485 48.072 5.967 61.998.535c1.746-.682 3.656-.688 5.446-.152 3.488 1.044 9.712 2.976 12.438 5.268",
    fill: "#4C6772",
    transform: "translate(-250 -439) translate(250 439) translate(82.154 28.462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.38 43.906L79.045 8.182c-.668-2.376-10.12-5.074-12.236-5.708-1.356-.406-2.754-.394-4.004.094-7.868 3.07-45.929 19.61-50.069 22.834-1.754 1.364-3.08 3.11-4.676 6.028L5.24 36.59l16.14 7.316z",
    fill: "#4C6772",
    transform: "translate(-250 -439) translate(250 439) translate(82.154 28.462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.324 7.228c.344-.15.86-.098 1.164.124 1.106.606 1.352 5.018-1.482 14.254-.332 1.082-1.042 1.866-2.056 2.386l-55 28.128c-2.786 1.426-4.582.76-7.252-.85L3.952 46a3.574 3.574 0 01-1.454-4.5c2.968-6.88 6.974-14.318 11.48-12.908 2.592.174 7.06.876 10.61 2.062 1.342 1.214 3.746.628 5.378-.724 5.896-3.678 35.974-17.758 47.358-22.702",
    fill: "#122E44",
    transform: "translate(-250 -439) translate(250 439) translate(82.154 28.462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.68 6.915c1.955-.738 3.435 2.35 1.315 3.204-12.16 4.872-31.152 14.188-42.505 20.478-7.278 4.034-13.672 13.406-16.832 20.97-.898 2.154-3.564 1.81-2.37-1.202 3.18-8.02 7.902-16.84 15.384-21.632C42.6 21.731 64.302 11.905 76.681 6.915",
    fill: "#131F24",
    transform: "translate(-250 -439) translate(250 439) translate(82.154 28.462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.977 28.593c-2.244-.432-2.202-3.198.33-2.832 4.222.606 7.97 2.556 10.742 5.34 1.608 1.614-.228 3.414-1.972 1.94-2.792-2.36-5.478-3.752-9.1-4.448",
    fill: "#96B5BD",
    transform: "translate(-250 -439) translate(250 439) translate(82.154 28.462)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -439) translate(250 439) translate(82.154 28.462) translate(59.716 62.048)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#l"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.928 75.602L27.36 5.89c1.542-4.228 4.446-6.27 8.352-5.832 3.802.426 11.464 1.02 15.214 1.44 4.87.546 7.59 2.856 7.16 8.132l-.994 11.392-21.664 82.602c-1.216 4.642-3.324 6.29-7.994 5.776L6.37 107.084c-4.452-.49-6.376-3.29-6.37-7.738L.022 84.26c.004-3.556.582-5.028 1.906-8.658",
    fill: "#C89A6C",
    mask: "url(#m)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.52 87.69l-6.262-7.984-38.674 59.378c-1.782 3.172-1.564 5.036-1.588 7.494l-.142 15.074c-.026 2.796.9 3.96 3.466 4.242l21.566 2.37c2.726.3 3.936-1.392 4.53-4.05L109.52 87.69z",
    fill: "#D1D3CA",
    transform: "translate(-250 -439) translate(250 439) translate(82.154 28.462)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -439) translate(250 439) translate(169.144 95.324)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#n"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.826 74.308c-.598 2.302-.678 4.716-.998 7.072L2.57 97.924c-.114.844-.532 3.558-2.57 3.378 3.046.446 4.46-.316 5.264-3.326l22.18-83.14.842-10.266C28.46 2.428 27.828.586 25.192 0L5.826 74.308z",
    fill: "url(#o)",
    mask: "url(#p)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.842 43.93c.582-1.963-1.656-3.15-3.738-3.33l-15.478-1.335c-2.316-.2-4.326 1.672-5.102 3.838l-25.34 70.812c-.594 1.66.406 3.468 2.102 3.754 3.952.662 17.664 2.016 22.882 2.204 1.064.036 2.46-.898 2.762-1.92L67.842 43.93z",
    fill: "#FFF",
    transform: "translate(-250 -439) translate(250 439) translate(128.294 54.231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.44 121.104c-1.095-.106-1.915-.928-1.833-1.836.084-.906 1.038-1.554 2.132-1.448l21.416 2.112c1.094.108 1.914.93 1.832 1.836-.084.906-1.038 1.554-2.132 1.448l-21.416-2.112z",
    fill: "#BDAE8E",
    transform: "translate(-250 -439) translate(250 439) translate(128.294 54.231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.366 69.16C14.954 68.186 6.86 64.5 2.574 62.688c-2.662-1.126-3.016-4.46-2.158-6.85.896-2.494 1.928-4.97 2.996-7.392 1.088-2.466 2.276-5.166 3.702-7.488 2.1-3.424 4.596-6.572 7.256-9.576 7.83-8.846 16.756-17.884 25.424-25.878 1.584-1.458 3.41-3.164 5.194-4.37C46.37.2 48.018-.203 49.676.099c2.608.474 8.064 3.022 10.592 4.548 3.78 2.282 4.234 4.012 2.798 7.942-.946 2.588-2.178 4.934-3.356 7.368-1.036 2.14-1.504 2.644-3.048 4.69L24.294 67.525c-1.524 2.018-3.754 2.256-5.928 1.636",
    fill: "#4C6772",
    transform: "translate(-250 -439) translate(250 439) translate(128.294 54.231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.796 57.144L61.588 9.008c.48-1.962-10.708-6.47-12.298-6.758-1.018-.186-2.09.038-3.062.694-4.382 2.958-18.9 17.77-27.364 26.78-3.94 4.194-7.563 8.368-10.303 13.106l-3.598 8.102 16.833 6.212z",
    fill: "#4C6772",
    transform: "translate(-250 -439) translate(250 439) translate(128.294 54.231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.482 8.615c.266-.194.462-.546.686-.38.73.55.516 1.726-.168 3.598-1.23 3.364-2.644 5.76-4.012 8.732L22.532 66.209c-1.684 2.23-5.546.2-7.646-.69L3.427 60.675c-1.224-.518-1.55-2.396-.94-4.094 1.498-4.172 4.316-10.578 6.074-13.75 1.632-2.948 3.228-3.732 5.69-3.58 2.009.122 5.345 3.856 9.96 5.534 2.667.968 4.283-.426 5.673-1.822 4.558-4.574 21.72-27.886 30.598-34.348",
    fill: "#122E44",
    transform: "translate(-250 -439) translate(250 439) translate(128.294 54.231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.206 8.497c1.336-1.31 1.774 1 .434 2.634-8.364 10.19-18.37 20.708-25.2 30.208-4.504 6.26-8.776 14.104-13.84 24.378-1.03 2.09-2.792 2.274-1.764-.796 4.082-12.208 8.232-19.4 12.594-25.18 7.092-9.4 19.478-23.108 27.776-31.244",
    fill: "#131F24",
    transform: "translate(-250 -439) translate(250 439) translate(128.294 54.231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.107 42.034c-2.485-.452-2.707-3.286.086-2.904 4.652.64 8.922 2.654 12.206 5.518 1.906 1.662.084 3.5-1.956 1.984-3.268-2.432-6.328-3.87-10.336-4.598",
    fill: "#96B5BD",
    transform: "translate(-250 -439) translate(250 439) translate(128.294 54.231)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonKeys);
export default __webpack_public_path__ + "static/media/lesson-keys.6658ec5c2991f962d2a59627ea52c7fc.svg";
export { ForwardRef as ReactComponent };